/* eslint-disable */
let COMMON_ENV = {
  version: '', // 版本号 接口获取
  SSO_URL: 'http://test.5ifapiao.com:8888', // 单点登录相关地址
  CLIENT_ID: 'fatr', // 登录对接CLIENT_ID
  COMMON_REPLACE_URL: 'COMMONREPLACEURL', // #号替换字段?COMMONREPLACEURL=
  COMMON_TOKEN: 'lawsinfo_token', // token字段名称
  COMMON_TOKEN_DAY: 0, // token 失效时间 0代表关闭浏览器就失效
  SOURCE_URL: window.location.href, // 获取网站信息的url，当前网址
  PROJECT_NAME_H5: 'lawsinfo_web_h5', // h5项目名称，用于生成二维码
  PROJECT_NAME_WEB: 'lawsinfo-web', // web项目名称
  expert_product_id: 'a2cc30f6552542ad8d22155f96adba30', // 优税专家相关
  login_product_id: '036a01086f1342d48f9af733a4d521d6', // 调用用户中心
  // 友盟id
  youMengId: '1279086082',
  // 百度id
  baiDuId: '3b8ad7e5c1f15461bbf55a9f4f06016c'
}

if (process.env.VUE_APP_ENV === 'production') {
  // 生产环境
  COMMON_ENV.SSO_URL = 'https://passport.utax360.cn'
  COMMON_ENV.lawsinfo_url = 'https://efats.utax360.cn' //调取IM的host
  COMMON_ENV.youMengId = '1279091950'
  COMMON_ENV.baiDuId = '5efd8b45fff593e05a10ddcfb611ba0f'
} else if (process.env.VUE_APP_ENV === 'development') {
  // 开发环境
  COMMON_ENV.SSO_URL = 'http://test.5ifapiao.com:8888'
  COMMON_ENV.SOURCE_URL = 'http://test.5ifapiao.com:8888/lawsinfo-web-110108008' // 开发环境用测试环境
  COMMON_ENV.lawsinfo_url = 'http://test.5ifapiao.com:8888' // 调取IM的host
} else if (process.env.VUE_APP_ENV === 'test') {
  // 测试环境
  COMMON_ENV.SSO_URL = 'http://test.5ifapiao.com:8888'
  COMMON_ENV.lawsinfo_url = 'http://test.5ifapiao.com:8888' // 调取IM的host
} else if (process.env.VUE_APP_ENV === 'pre') {
  // 预发环境
  COMMON_ENV.SSO_URL = 'https://sso-pre.ele-cloud.com'
  COMMON_ENV.lawsinfo_url = 'https://efats-pre.ele-cloud.com' // 调取IM的host
}

export default COMMON_ENV
